function contains(node: Node | null): boolean {
  // eslint-disable-next-line prefer-rest-params
  if (!(0 in arguments)) {
    throw new TypeError('1 argument is required');
  }

  do {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (this === node) {
      return true;
    }
    // eslint-disable-next-line no-cond-assign
  } while (node = node && node.parentNode);

  return false;
}

export default function(): void {
  if ('Node' in window && typeof Node.prototype.contains === 'undefined') {
    Node.prototype.contains = contains;
  } else if ('HTMLElement' in window && typeof HTMLElement.prototype.contains === 'undefined') {
    document.contains = HTMLElement.prototype.contains = contains;
  }
}
